import type { LayoutConfig } from './dealCalculations'
import {
  DEFAULT_BONUS_Y,
  DEFAULT_DESCRIPTION_Y,
  DEFAULT_LOYALTY_Y,
  DEFAULT_NEGOTIATION_Y,
  DEFAULT_PAYMENT_Y,
  DEFAULT_PRICE_Y,
  DEFAULT_PROJECT_TYPE_Y,
  DEFAULT_SUPPORT_HOURS_Y,
  DEFAULT_TITLE_Y,
} from './dealCalculations'
import { normalizeTextEncoding } from './text-normalization'

/**
 * Layout validado no Proposal Studio — slide "Suporte e Evolução" (combo slide 2 com preço).
 */
export const SUPORTE_EVOLUCAO_SLIDE_LAYOUT: Partial<LayoutConfig> = {
  leftBlockWidth: 35,
  titleY: DEFAULT_TITLE_Y,
  projectTypeY: DEFAULT_PROJECT_TYPE_Y,
  descriptionY: DEFAULT_DESCRIPTION_Y,
  supportHoursY: DEFAULT_SUPPORT_HOURS_Y,
  bonusY: DEFAULT_BONUS_Y,
  priceY: DEFAULT_PRICE_Y,
  paymentY: DEFAULT_PAYMENT_Y,
  loyaltyY: DEFAULT_LOYALTY_Y,
  negotiationY: DEFAULT_NEGOTIATION_Y,
  planTitleY: 2.7,
  serviceBlockStartY: 10,
  serviceBlockX: 38,
  categoryCoords: {
    'Serviços Disponíveis': { x: 38, y: 10 },
  },
}

export function isSuporteEvolucaoPlanName(name: string): boolean {
  const key = normalizeTextEncoding(name).toLowerCase().trim()
  return key === 'suporte e evolução' || key.includes('suporte e evolu')
}

export function isSuporteEvolucaoPlan(
  plan: { descricao?: string; nome?: string; name?: string },
): boolean {
  const label = plan.descricao || plan.nome || plan.name || ''
  return isSuporteEvolucaoPlanName(label)
}

export function mergeSuporteEvolucaoSlideLayout(layout: LayoutConfig): LayoutConfig {
  return { ...layout, ...SUPORTE_EVOLUCAO_SLIDE_LAYOUT }
}
